import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { FuseAnimate, TextFieldFormsy} from '@fuse';
import { DialogContent, CircularProgress, Dialog, Icon, InputAdornment, Card, CardContent, Hidden, Paper, Button, Typography, Divider, DialogActions, Grid } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import Formsy from 'formsy-react';
import classNames from 'classnames';

// import LoginSlider from './LoginSlider';

import green from '@material-ui/core/colors/green';

const styles = theme => ({
    layoutRoot: {},
    success: {
        backgroundColor: green[600],
    },
    root: {
        color : theme.palette.primary.contrastText
    },
    icon : {
        marginBottom: '-6px'
    },
    loadingMasuk: {
        position: 'absolute',
        width: '100%',
        bottom: 0,
        height: 2
    },
    hut: {
        position: 'absolute',
        top: 24,
        right: 24,
        maxWidth: 74
    }
});

class RegistrasiDapodik extends Component {

    state = {
        error: null,
        isLoaded: false,
        namaPengguna: 'Khalid',
        bottom: false,
        ListMenu: null,
        email: null,
        canSubmit: true,
        loading_besar: false,
        pesan_kesalahan: false,
        routeParams: {
            // peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
            // token: localStorage.getItem('jwt_token')
            media_id: localStorage.getItem('tipe_app')
        },
        disableButton: false,
        pesan_kesalahan_teks: 'error',
        dialog_error: false,
        dialog_error_beneran: false,
        sekolah: {
            rows: [{
                nama: ''
            }]
        },
        pengguna: {
            hasil: {
                berhasil: 0,
                gagal: 0
            }
        },
        alamat_dapodik: 'localhost:5774'
    };

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    componentDidMount = () => {
        this.props.setJudul("Registrasi Pengguna Baru");
    }

    onSubmit = (model) => {
        this.setState({
            routeParams:{
                ...this.state.routeParams,
                npsn: model.npsn,
                kode_registrasi: model.kode_registrasi,
                alamat: model.alamat
            },
            loading_besar: true
        },()=>{
            this.props.getKoregDapodik(this.state.routeParams).then((result)=>{

                // console.log(result.payload.koreg);return true;

                if(result.payload.koreg.toLowerCase() === this.state.routeParams.kode_registrasi.toLowerCase()){
                    //sama
                    this.props.RegistrasiDapodikSekolah(this.state.routeParams).then((result)=>{
        
                        if(result.payload.success){
                            //berhasil
                            this.setState({
                                sekolah: result.payload
                            },()=>{
            
                                console.log(this.state.sekolah);
            
                                this.props.RegistrasiDapodik(this.state.routeParams).then((resultPengguna)=>{
            
                                    this.setState({
                                        pengguna: resultPengguna.payload,
                                        loading_besar: false,
                                        dialog_error: true
                                    },()=>{
            
                                        console.log(this.state.pengguna);
                                    
                                    })
            
                                })
            
                            })
                        }else{
                            //gagal
                            this.setState({
                                loading_besar: false,
                                dialog_error: false,
                                dialog_error_beneran: true
                            })
                        }
        
                        
        
                    })
                }else{
                    //tidak sama
                    this.setState({
                        loading_besar: false,
                        dialog_error: false,
                        dialog_error_beneran: true
                    })
                }
            });
            // return true;

        });

    };

    handleChange = (e) => (key) => {
        this.setState({
            routeParams: {
                [key] : e.target.value
            }
        },()=>{
            console.log(this.state);
        })
    }

    render()
    {
        const {classes} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', background:'#287A22'}}>
            {/* <div className={classNames(classes.root, "w-full flex flex-col flex-1 p-16 sm:p-0 md:flex-row justify-center konten-utama")} style={{marginBottom:'0px',width:'100%', backgroundImage:'linear-gradient(to left, #f9d423 0%, #ff4e50 100%)'}}> */}
                <Dialog
                    open={this.state.dialog_error}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <b style={{fontSize:'20px'}}>Proses Registrasi Selesai!</b>
                        <br/>
                        <br/>
                        <b>{this.state.sekolah.rows[0].nama}</b>
                        <br/>
                        Pengguna Total: {parseInt(this.state.pengguna.hasil.berhasil)+parseInt(this.state.pengguna.hasil.gagal)}<br/>
                        Registrasi Berhasil: {parseInt(this.state.pengguna.hasil.berhasil)}<br/>
                        Registrasi Gagal: {parseInt(this.state.pengguna.hasil.gagal)}<br/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{this.setState({dialog_error:false});this.props.history.push('/login')}}>Tutup</Button>
                    </DialogActions>
                </Dialog>
                
                <Dialog
                    open={this.state.dialog_error_beneran}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <b style={{fontSize:'20px'}}>Proses Registrasi Gagal!</b>
                        <br/>
                        <br/>
                        Sekolah tidak ditemukan atau kode registrasi salah! Silakan coba kembali dengan memastikan isian NPSN dan alamat dapodik telah sesuai!
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>{this.setState({dialog_error_beneran:false});}}>Tutup</Button>
                    </DialogActions>
                </Dialog>
                
                <Dialog
                    open={this.state.loading_besar}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <CircularProgress className={classes.progress} style={{marginLeft:'20px', marginRight:'20px'}}/>
                        <br/>
                        Proses registrasi dengan Dapodik sedang berlangsung. Mohon tunggu beberapa saat...
                        {/* <br/> */}
                        {/* Ketika berhasil, Anda akan diarahkan kembali ke halaman login */}
                    </DialogContent>
                </Dialog>
                {/* <Dialog
                    open={this.state.pesan_kesalahan}
                >
                    <DialogContent style={{background:'#ff8a80',color:'black', textAlign: 'center'}} id="error-dialog">
                        Pengguna tidak ditemukan atau password salah. Mohon cek kembali informasi pengguna Anda!
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    pesan_kesalahan: false
                                })
                            }}
                        >Tutup</Button>
                    </DialogActions>
                </Dialog> */}
                <Hidden smDown>
                    <div className="relative flex flex-col flex-no-grow items-center justify-center text-white p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                        {/* <FuseAnimate animation="transition.expandIn"> */}
                        <img className="mb-16" src="/assets/images/logos/logopmp.png" alt="logo" style={{width:'128px', height:'128px', marginTop:'-100px'}} />
                        {/* </FuseAnimate> */}
                        <FuseAnimate animation="transition.slideUpIn" delay={300}>
                            <div>
                                <Typography variant="display1" color="inherit" className="font-light font-bold uppercase">
                                    {localStorage.getItem('judul_aplikasi')}
                                </Typography>
                                <Typography variant="display2" color="inherit" className="font-light" style={{fontSize:'30px'}}>
                                    {localStorage.getItem('bos_aplikasi')}
                                </Typography>
                                <Typography variant="body2" color="inherit" className="text-grey-ligther">
                                    {localStorage.getItem('badan_aplikasi')}
                                </Typography>
                                <Typography variant="display1" color="inherit" className="font-light">
                                    <i style={{color:'yellow'}}>versi OFFLINE</i> <i style={{color:'yellow'}}>{localStorage.getItem('versi_app')}</i>
                                </Typography>
                            </div>
                        </FuseAnimate>
                        <br/>
                        <br/>
                        <FuseAnimate animation="transition.slideUpIn" delay={300} >
                            <Grid container style={{position: 'fixed', bottom:'0px'}}>
                                <Grid item xs={2} sm={1} style={{border:'0px solid red'}}>
                                    <img className="mb-16" src="/assets/images/logos/logo_dapodik.png" alt="logo" style={{width:'60px'}} />
                                </Grid>
                                <Grid item xs={10} sm={11} style={{border:'0px solid red', paddingTop:'10px'}}>
                                    Terintegrasi dengan
                                    <br/>
                                    <b style={{fontSize:'20px'}}>Dapodik</b>
                                </Grid>
                            </Grid>
                        </FuseAnimate>
                        <br/>
                        {/* <FuseAnimate animation="transition.slideUpIn" delay={300} > */}
                        <img className="mb-16" src="/assets/images/hardiknas2020.png" alt="logo" width={100} />
                        <br/>
                        <div style={{fontSize:'20px', marginTop:'-30px', fontStyle:'italic'}}>"Belajar dari Covid-19"</div>
                    </div>
                </Hidden>
                {/* <FuseAnimate animation={{translateX: [0, '100%']}}> */}
                    <Card style={{maxWidth:'400px', height:'100%'}} className="flex flex-col items-center justify-center w-full mx-auto m-16 md:m-0 rounded-8 sm:rounded-none" square>
                        <CardContent className="w-full p-16 sm:p-32">
                            <Hidden smUp>
                                <div className="flex flex-col flex-no-grow items-center justify-center text-white mb-24 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left">
                                    <FuseAnimate animation="transition.expandIn">
                                        <img className="w-80 mb-16" src="/assets/images/logos/logopmp.png" alt="logo" />
                                    </FuseAnimate>
                                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                                        <div>
                                            <Typography variant="h4" color="primary" className="font-bold uppercase text-18">
                                                {localStorage.getItem('judul_aplikasi')}
                                            </Typography>
                                            <Typography variant="h5" color="inherit" className="text-grey-darkest text-14">
                                                {localStorage.getItem('bos_aplikasi')}
                                            </Typography>
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </Hidden>
                            <Typography variant="h6" className="font-bold text-center uppercase md:w-full mb-48 hidden sm:block" color="primary">Tarik Data {localStorage.getItem('judul_aplikasi')}<br/>dari Dapodik</Typography>
                            <div className="w-full">
                                {/* background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) */}
                                <Paper className="p-8" style={{backgroundImage:'linear-gradient(to top, #c471f5 0%, #fa71cd 100%)'}}>
                                    <Typography variant="caption" style={{color:'#ffffff', fontSize:'15px'}}>
                                        Proses ini akan membaca dan mengambil data dapodik dari Aplikasi Dapodik yang terinstall di komputer Anda. Mohon pastikan bahwa Aplikasi Dapodik berjalan dengan normal
                                    </Typography>
                                </Paper>
                                <br/>
                                <Formsy
                                    onValidSubmit={this.onSubmit}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="npsn"
                                        label="NPSN"
                                        validations={{
                                            minLength: 4
                                        }}
                                        variant="outlined"
                                        required
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="kode_registrasi"
                                        label="Kode Registrasi"
                                        validations={{
                                            minLength: 9
                                        }}
                                        variant="outlined"
                                        required
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="text"
                                        name="alamat"
                                        label="URL Aplikasi Dapodik (Contoh: localhost:5774)"
                                        variant="outlined"
                                        required
                                        value={this.state.alamat_dapodik}
                                    />
                                    <div style={{fontSize:'12px', color:'#434343', textAlign:'center', fontStyle:'italic'}}>
                                        Silakan ubah alamat URL diatas bila Aplikasi Dapodik Anda menggunakan Alamat URL yang berbeda dengan bawaan installer
                                    </div>
                                    <br/>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Masuk"
                                        disabled={!canSubmit}
                                        value="legacy"
                                    >
                                        Tarik Data
                                    </Button>
                                    <Divider/>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                        className="w-full mx-auto mt-16 normal-case relative"
                                        aria-label="Masuk"
                                        disabled={!canSubmit}
                                        value="legacy"
                                        onClick={()=>window.location.href="/login"}
                                    >
                                        Kembali ke Login
                                    </Button>
                                </Formsy>
                            </div>
                        </CardContent>
                    </Card>
                {/* </FuseAnimate> */}
                
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        setJudul: Actions.setJudul,
        RegistrasiDapodik: Actions.RegistrasiDapodik,
        RegistrasiDapodikSekolah: Actions.RegistrasiDapodikSekolah,
        getKoregDapodik: Actions.getKoregDapodik
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RegistrasiDapodik)));



// WEBPACK FOOTER //
// ./src/main/content/login/RegistrasiDapodik.js